import { render, staticRenderFns } from "./ProductDeatail.vue?vue&type=template&id=363a988f&scoped=true&"
import script from "./ProductDeatail.vue?vue&type=script&lang=js&"
export * from "./ProductDeatail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDeatail.vue?vue&type=style&index=0&id=363a988f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a988f",
  null
  
)

export default component.exports